// extracted by mini-css-extract-plugin
export var active = "_1p-d";
export var blink = "_1p-e";
export var container = "_1p-5";
export var controls = "_1p-0";
export var controlsRight = "_1p-1";
export var fakeCursor = "_1p-c";
export var hidden = "_1p-b";
export var quillContainerSmall = "_1p-7";
export var quillEditor = "_1p-6";
export var quillEditorSmall = "_1p-8";
export var quillFormatButtons = "_1p-a";
export var quillToolbar = "_1p-9";
export var removePadding = "_1p-2";
export var state = "_1p-3";
export var stateTitle = "_1p-4";